import React from "react";
import { Typography } from "antd";

const { Text } = Typography;

const ProductDetailsBox = ({ productName, sku, msrp, salePrice, isExpanded }) => {
  return (
    <div className="ProductDetailsBox">
      <div className={`DetailBox ${isExpanded ? "ExpandedDetailBox" : ""}`}>
        <div className="DetailInner DetailInnerName">
          <Text type="secondary">
            <span>Product Name:</span> {productName}
          </Text>
        </div>
        <div className="DetailInner DetailInner-15">
          <Text type="secondary">
            <span>BC SKU:</span> {sku}
          </Text>
        </div>
        <div className="DetailInner DetailInner-15">
          <Text type="secondary">
            <span>Store MSRP:</span> {msrp}
          </Text>
        </div>
        <div className="DetailInner DetailInner-15">
          <Text type="secondary">
            <span>Store Sale Price:</span> {salePrice}
          </Text>
        </div>
      </div>
    </div>
  );
};

export default ProductDetailsBox;
